import React from 'react';
import PropTypes from 'prop-types';
import PhosphorIcon from '../icons/PhosphorIcon';
import styles from './icon.module.scss';

// Keyed by HelpScout category id, accents are TGDS accent token names
const iconMap = {
  '6a021cfef97dd896ebfc81ba': {name: 'question', accent: 'sky'},
  '5511aff4e4b061031401fb4c': {name: 'rocketLaunch', accent: 'indigo'},
  '5f510e62c9e77c0016384617': {name: 'layout', accent: 'sky'},
  '5284de2fe4b027e0d843bc97': {name: 'chatsCircle', accent: 'teal'},
  '526eaf43e4b06c89ec332a52': {name: 'chartBarHorizontal', accent: 'amethyst'},
  '5afb35e42c7d3a640ed6de95': {name: 'chartLineUp', accent: 'salmon'},
  '5284df24e4b027e0d843bca8': {name: 'lightbulb', accent: 'twine'},
  '57e9e78d9033602e61d4835c': {name: 'userGear', accent: 'rose'},
  '5284dea7e4b04fbdf2ac3a02': {name: 'timer', accent: 'mantis'},
  '528a6bcee4b0bb9de0e9a1f6': {name: 'plugsConnected', accent: 'leaf'},
};

const DEFAULT_ICON = {name: 'bookOpen', accent: 'teal'};

const Icon = ({category}) => {
  const {name, accent} = iconMap[category.id] || DEFAULT_ICON;
  const style = {
    backgroundColor: `var(--color-accent-${accent}-100)`,
    color: `var(--color-accent-${accent}-600)`,
  };

  return (
    <span className={styles.Icon} style={style}>
      <PhosphorIcon name={name} size={24} />
    </span>
  );
};

Icon.propTypes = {
  category: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
};

export default Icon;



// WEBPACK FOOTER //
// ./src/components/topics/Icon.js